import { styled } from "@mui/material/styles";
import { ReactComponent as MapMarkerAlt } from "src/assets/icons/map-marker-alt.svg";

interface MapMarkerIconProps {
  color?: string;
}

export const MapMarkerIcon = styled(MapMarkerAlt, {
  shouldForwardProp: (prop) => prop !== "color",
})<MapMarkerIconProps>`
  .a {
    fill: ${({ color }) => color ?? "#3fabff"};
  }
`;
